module.exports = __webpack_public_path__ + "img/icon-coins.8b3c1421.svg";